// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../img/dark-bg-2.jpeg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AdminDashboard_dashboard__Eqtec {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding: 0 2rem 5rem;
}
.AdminDashboard_dashboard__header__EAV\\+K {
  padding: 2rem;
  border-radius: 1.2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1.2rem;
  flex-wrap: wrap;
  background-image: linear-gradient(to bottom right, var(--color-fash-black-2), rgba(0, 0, 0, 0)), url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
}
.AdminDashboard_dashboard__top__MnVB5 {
  display: flex;
  gap: 1.2rem;
  justify-content: space-between;
  align-items: center;
  margin-top: 2rem;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Admin/AdminDashboard.module.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,sBAAA;EACA,SAAA;EACA,oBAAA;AACD;AACC;EACC,aAAA;EACA,qBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EAEA,wIAAA;EAOA,sBAAA;EACA,2BAAA;AANF;AASC;EACC,aAAA;EACA,WAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;AAPF","sourcesContent":[".dashboard {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 2rem;\n\tpadding: 0 2rem 5rem;\n\n\t&__header {\n\t\tpadding: 2rem;\n\t\tborder-radius: 1.2rem;\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t\tgap: 1.2rem;\n\t\tflex-wrap: wrap;\n\t\t// background-color: var(--color-fash-black-2);\n\t\tbackground-image: linear-gradient(\n\t\t\t\tto bottom right,\n\t\t\t\tvar(--color-fash-black-2),\n\t\t\t\trgba(0, 0, 0, 0)\n\t\t\t),\n\t\t\turl('../../img/dark-bg-2.jpeg');\n\n\t\tbackground-size: cover;\n\t\tbackground-position: center;\n\t}\n\n\t&__top {\n\t\tdisplay: flex;\n\t\tgap: 1.2rem;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t\tmargin-top: 2rem;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `AdminDashboard_dashboard__Eqtec`,
	"dashboard__header": `AdminDashboard_dashboard__header__EAV+K`,
	"dashboard__top": `AdminDashboard_dashboard__top__MnVB5`
};
export default ___CSS_LOADER_EXPORT___;
